import {
  Container,
  Row,
  Col,
  Form,
  Card,
  Modal,
  Button,
} from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "./Login.css";
import WhiteButton from "./../common_components/common_button/WhiteButton";
import {
  faAngleRight,
  faAngleLeft,
  faArrowLeft,
  faEyeSlash,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  faInstagram,
  faFacebookF,
  faXTwitter,
  faYoutube,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import Login_Succes_Lottie from "./../animation/login_succes_lottie/Login_Succes_Lottie";
import {
  GETProfile,
  sendMobileOtp,
  verifyOtp,
  createSignup,
  customerLogin,
  forgotPassword,
} from "../../features/admin/auth/Slice";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";

export default function Login() {
  const dispatch = useDispatch();
  const swiperRef = useRef(null);
  const navigate = useNavigate();

  const [step, setStep] = useState(1); // 1: Login, 4: Forgot Mobile/OTP, 5: Reset Password
  const [signupStep, setSignupStep] = useState(1);
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [generalError, setGeneralError] = useState("");
  const [formType, setFormType] = useState("login");
  const [successType, setSuccessType] = useState("");

  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);

  const [showOtpBox, setShowOtpBox] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);

  const [showInactiveModal, setShowInactiveModal] = useState(false);

  const [inactiveMessage, setInactiveMessage] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
  } = useForm();

  const password = watch("password");

  const images = [
    "/images/login/formbgimg.png",
    "/images/login/formbgimg2.png",
  ];

  // Timer Effect
  useEffect(() => {
    if (!showOtpBox) return; // ⛔ STOP if OTP not visible

    let interval;

    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      // ⛔ TIMER FINISHED

      setCanResend(true);
      setOtp(["", "", "", ""]);
      setOtpError("");

      // ✅ HIDE OTP BOX
      setShowOtpBox(false);

      // ✅ RESET OTP VERIFIED
      setOtpVerified(false);
    }

    return () => clearInterval(interval);
  }, [timer, showOtpBox]);

  // OTP Handlers
  const handleOtpChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (otpError) setOtpError("");
      if (value && index < otp.length - 1) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  // const handleResendOtp = async () => {
  //   try {
  //     setOtpError("");
  //     const res = await dispatch(
  //       sendMobileOtp({ mobile_number: phone }),
  //     ).unwrap();
  //     if (res?.success) {
  //       setTimer(30);
  //       setCanResend(false);
  //       setOtp(["", "", "", ""]);
  //       setShowOtpBox(true);
  //       setOtpVerified(false);
  //       inputRefs.current[0]?.focus();
  //     }
  //   } catch (error) {
  //     setOtpError(error?.message || "Something went wrong");
  //   }
  // };
  const handleResendOtp = async () => {
    try {
      setOtpError("");

      const payload = {
        mobile_number: phone,
        type: formType === "signup" ? "signup" : "forgot_password",
      };

      const res = await dispatch(sendMobileOtp(payload)).unwrap();

      if (res?.success) {
        setTimer(30);
        setCanResend(false);
        setOtp(["", "", "", ""]);
        setShowOtpBox(true);
        setOtpVerified(false);
        inputRefs.current[0]?.focus();
      }
    } catch (error) {
      setOtpError(error?.message || "Something went wrong");
    }
  };

  // Send OTP (Common for Signup & Forgot)
  // const sendOtpHandler = async (data) => {
  //   try {
  //     setMobileError("");
  //     setOtpError("");
  //     const res = await dispatch(sendMobileOtp(data)).unwrap();
  //     if (res?.success) {
  //       setPhone(data.mobile_number);
  //       setTimer(30);
  //       setCanResend(false);
  //       setOtp(["", "", "", ""]);
  //       setShowOtpBox(true);
  //       setOtpVerified(false);
  //     } else {
  //       setMobileError(res?.message || "Failed to send OTP");
  //     }
  //   } catch (error) {
  //     setMobileError(error?.message || "Something went wrong");
  //   }
  // };
  const sendOtpHandler = async (data) => {
    try {
      setMobileError("");
      setOtpError("");

      // ✅ ADD TYPE BASED ON FORM
      const payload = {
        ...data,
        type: formType === "signup" ? "signup" : "forgot_password",
      };

      const res = await dispatch(sendMobileOtp(payload)).unwrap();

      if (res?.success) {
        setPhone(data.mobile_number);
        setTimer(30);
        setCanResend(false);
        setOtp(["", "", "", ""]);
        setShowOtpBox(true);
        setOtpVerified(false);
      } else {
        setMobileError(res?.message || "Failed to send OTP");
      }
    } catch (error) {
      setMobileError(error?.message || "Something went wrong");
    }
  };
  const [activeNav, setActiveNav] = useState("");
  // Verify OTP
  const verifyOtpHandler = async (e) => {
    e.preventDefault();
    const otpValue = otp.join("");
    if (otpValue.length !== 4) {
      setOtpError("Please enter complete 4-digit OTP");
      return;
    }

    try {
      const res = await dispatch(
        verifyOtp({ mobile_number: phone, otp: otpValue }),
      );
      if (res?.payload?.success) {
        setOtpError("");
        setOtpVerified(true);

        if (formType === "signup") {
          setSignupStep(2);
        } else if (formType === "login") {
          setStep(5); // Move to Reset Password screen
        }
      } else {
        setOtpError(res?.payload?.message || "Invalid OTP");
      }
    } catch (error) {
      setOtpError(error?.message || "Verification failed");
    }
  };

  // Signup Final
  const handleSignupFinal = async (data) => {
    try {
      setGeneralError("");

      const payload = {
        mobile_number: phone,
        password: data.password,
        confirm_password: data.confirm_password,
        invitation_referral_code: data.invitation_referral_code || "",
      };

      const res = await dispatch(createSignup(payload)).unwrap();

      if (res?.success) {
        setFormType("login");
        setSuccessType("signup");
        setStep(3);
      } else {
        setGeneralError(res?.message || "Signup failed");
      }
    } catch (error) {
      setGeneralError(error?.message || "Something went wrong");
    }
  };

  // Normal Login (Mobile + Password)
  const handleCustomerLogin = async (data) => {
    try {
      setGeneralError("");
      const res = await dispatch(customerLogin(data)).unwrap();
      if (res?.success && res?.data?.token) {
        Cookies.set("spirulina_website_security", res.data.token, {
          expires: 7,
          secure: true,
          sameSite: "strict",
        });

        await dispatch(GETProfile());

        // ✅ Show success animation briefly
        setSuccessType("login");
        setStep(3);

        setTimeout(() => {
          window.location.href = "/home"; // 🔥 FULL PAGE REFRESH
          // navigate("/home");
        }, 1500);
      } else {
        setGeneralError(res?.message || "Login failed");
      }
    } catch (error) {
      setGeneralError(error?.message || "Invalid credentials");
    }
  };

  // Forgot Password Reset
  const handleForgotReset = async (data) => {
    try {
      setGeneralError("");
      const payload = {
        mobile_number: phone,
        password: data.password,
        confirm_password: data.confirm_password,
      };
      const res = await dispatch(forgotPassword(payload)).unwrap();
      if (res?.success) {
        // alert("Password reset successful! Please login with new password.");
        // setFormType("login");
        // setStep(1);
        setSuccessType("reset");
        setStep(3);

        reset();
        setPhone("");
        setOtp(["", "", "", ""]);
        setShowOtpBox(false);
        setOtpVerified(false);
      } else {
        setGeneralError(res?.message || "Password reset failed");
      }
    } catch (error) {
      setGeneralError(error?.message || "Something went wrong");
    }
  };

  // Success Redirect
  // useEffect(() => {
  //   if (step === 3) {
  //     const timeout = setTimeout(() => {
  //       navigate("/home");
  //     }, 2000);
  //     return () => clearTimeout(timeout);
  //   }
  // }, [step, navigate]);
  useEffect(() => {
    if (step === 3 && successType) {
      const timeout = setTimeout(() => {
        if (successType === "login") {
          navigate("/home");
        } else {
          // 👉 Signup & Reset → go to login screen
          setFormType("login");
          setStep(1);
        }

        // ✅ Common reset after success
        reset();
        setPhone("");
        setOtp(["", "", "", ""]);
        setShowOtpBox(false);
        setOtpVerified(false);
        setSuccessType("");
      }, 2000);

      return () => clearTimeout(timeout);
    }
  }, [step, successType, navigate]);

  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  useEffect(() => {
    const shouldShow = sessionStorage.getItem("show_inactive_modal");

    const message = sessionStorage.getItem("inactive_message");

    if (shouldShow === "true" && message) {
      setInactiveMessage(message);

      setShowInactiveModal(true);

      sessionStorage.removeItem("show_inactive_modal");
    }
  }, []);

  return (
    <div className="login-wrapper">
      <Swiper
        modules={[EffectFade, Autoplay, Navigation]}
        effect="fade"
        autoplay={{ delay: 3000 }}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        loop
        className="login-swiper"
      >
        {images.map((img, i) => (
          <SwiperSlide key={i}>
            <div
              className="bg-slide"
              style={{ backgroundImage: `url(${img})` }}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <Container fluid className="login-overlay container">
        <Row className="align-items-center h-100">
          {/* LEFT SIDE - Unchanged */}
          <Col
            xs={12}
            md={6}
            lg={6}
            className="contain-card text-white ps-lg-5 login-left"
          >
            <h1 className="signup-login">
              {formType === "login" ? "Login" : "Sign Up"}
            </h1>
            <h1 className="fw-bold my-4 sub-title">
              Fuel your body with nutrients,
              <br />
              not just food.
            </h1>
            <p className="fst-italic expand">Expand reach. Multiply success.</p>
            <div className="custom-nav">
              <div
                className={`custom-prev ${activeNav === "prev" ? "active" : ""
                  }`}
                onClick={() => {
                  swiperRef.current?.slidePrev();
                  setActiveNav("prev");
                }}
              >
                <FontAwesomeIcon icon={faAngleLeft} />
              </div>
              <div
                className={`custom-next ${activeNav === "next" ? "active" : ""
                  }`}
                onClick={() => {
                  swiperRef.current?.slideNext();
                  setActiveNav("next");
                }}
              >
                <FontAwesomeIcon icon={faAngleRight} />
              </div>
            </div>
            <div className="social-icon">
              <a href="https://instagram.com">
                <FontAwesomeIcon className="icon" icon={faInstagram} />
              </a>
              <a href="https://facebook.com">
                <FontAwesomeIcon className="icon" icon={faFacebookF} />
              </a>
              <a href="https://twitter.com">
                <FontAwesomeIcon className="icon" icon={faXTwitter} />
              </a>
              <a href="https://youtube.com">
                <FontAwesomeIcon className="icon" icon={faYoutube} />
              </a>
              <a href="https://linkedin.com">
                <FontAwesomeIcon className="icon" icon={faLinkedinIn} />
              </a>
            </div>

            {/* Policy Links */}

            <div className="login-footer-links">
              <Link to="/privacy-policy" className="footer-link">
                Privacy Policy
              </Link>

              <span className="mx-1">|</span>

              <Link to="/terms-conditions" className="footer-link">
                Terms & Conditions
              </Link>

              <span className="mx-1">|</span>

              <Link to="/return-policy" className="footer-link">
                Return Policy
              </Link>

              <span className="mx-1">|</span>

              <Link to="/refund-policy" className="footer-link">
                Refund Policy
              </Link>

              <span className="mx-1">|</span>

              <Link to="/shipping-policy" className="footer-link">
                Shipping Policy
              </Link>

              <span className="mx-1">|</span>

              <Link to="/cancellation-policy" className="footer-link">
                Cancellation Policy
              </Link>
            </div>
          </Col>

          {/* RIGHT SIDE */}
          {formType === "login" ? (
            <Col
              xs={12}
              md={6}
              lg={6}
              className="d-flex justify-content-center right-form"
            >
              {/* Normal Login */}
              {step === 1 && (
                <Card className="login-card border-0">
                  <Card.Body className="card-body p-4 text-center">
                    <img
                      className="main-logo"
                      src="images/logo/logo.png"
                      alt="Spirulina"
                    />
                    <h6 className="welcome-title">
                      Unlock the power of Spirulina
                    </h6>

                    <Form
                      className="mt-3 input-form"
                      onSubmit={handleSubmit(handleCustomerLogin)}
                    >
                      <div className="phone-input-wrapper">
                        <Form.Control
                          maxLength={10}
                          className="rounded-pill mb-2 input-filed pe-5"
                          placeholder="Enter Contact No."
                          {...register("mobile_number", {
                            required: "Phone is required",
                            pattern: {
                              value: /^[0-9]{10}$/,
                              message: "Enter valid 10 digit number",
                            },
                            onChange: () => {
                              setMobileError("");
                              setGeneralError("");
                            },
                          })}
                          onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            "",
                          ))
                          }
                        />
                      </div>
                      {errors.mobile_number && (
                        <small className="text-danger">
                          {errors.mobile_number.message}
                        </small>
                      )}

                      <div className="password_holder">
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          className="rounded-pill mb-2 input-filed"
                          placeholder="Enter Password"
                          {...register("password", {
                            required: "Password is required",
                          })}
                        />
                        {errors.password && (
                          <small className="text-danger">
                            {errors.password.message}
                          </small>
                        )}

                        {generalError && (
                          <small className="text-danger d-block mt-2">
                            {generalError}
                          </small>
                        )}

                        <div className="eye-icc">
                          <FontAwesomeIcon
                            icon={iconOne}
                            className="icon"
                            onClick={() => togglePasswordVisibility("password")}
                          />
                        </div>
                      </div>

                      <div
                        className="text-end mb-2"
                        onClick={() => {
                          setStep(4);
                          setGeneralError("");
                          setShowOtpBox(false);
                          reset();
                        }}
                      >
                        <span className="forgot-link">Forgot Password?</span>
                      </div>

                      <WhiteButton
                        className="center-btn login-btn"
                        title="Login"
                        bg="#000"
                        color="#f35f37"
                        hoverColor="#f35f37"
                        hoverBg="#000"
                        type="submit"
                      />

                      <div className="signup-wrapper text-center mt-3">
                        <span>
                          Don’t have an account?{" "}
                          <a
                            onClick={() => {
                              setFormType("signup");
                              setSignupStep(1);
                              reset();
                            }}
                            className="signup-link"
                          >
                            Sign up
                          </a>
                        </span>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              )}

              {/* Login Success */}
              {step === 3 && (
                <section>
                  <Card className="login-card secces-card border-0">
                    <Card.Body className="card-body succes-card-body text-center">
                      <img
                        className="main-logo"
                        src="images/logo/logo.png"
                        alt="Spirulina"
                      />
                      <div className="login-success-lottie">
                        <Login_Succes_Lottie />
                      </div>
                      <p className="enter-number">
                        {successType === "login" &&
                          "Login successful! Redirecting..."}
                        {successType === "signup" &&
                          "Signup successful! Please login."}
                        {successType === "reset" &&
                          "Password reset successful! Please login."}
                      </p>
                    </Card.Body>
                  </Card>
                </section>
              )}

              {/* Forgot Password - Mobile + OTP (Exact UI as reference) */}
              {step === 4 && (
                <Card className="login-card border-0">
                  <Card.Body className="card-body p-4 text-center">
                    <img
                      className="main-logo"
                      src="images/logo/logo.png"
                      alt="Spirulina"
                    />
                    <h6 className="welcome-title">RESET PASSWORD</h6>

                    <Form
                      className="mt-3 input-form"
                      onSubmit={handleSubmit(sendOtpHandler)}
                    >
                      <div className="phone-input-wrapper">
                        <Form.Control
                          maxLength={10}
                          className="rounded-pill mb-2 input-filed pe-5"
                          placeholder="Enter Contact No."
                          disabled={showOtpBox && !canResend}
                          {...register("mobile_number", {
                            required: "Phone is required",
                            pattern: {
                              value: /^[0-9]{10}$/,
                              message: "Enter valid 10 digit number",
                            },
                            onChange: () => {
                              setMobileError("");
                              setGeneralError("");
                            },
                          })}
                          onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            "",
                          ))
                          }
                        />
                      </div>
                      {errors.mobile_number && (
                        <small className="text-danger">
                          {errors.mobile_number.message}
                        </small>
                      )}
                      {mobileError && (
                        <small className="text-danger d-block">
                          {mobileError}
                        </small>
                      )}

                      {!showOtpBox && (
                        <>
                          <WhiteButton
                            className="center-btn submit-otp-button"
                            title="Send OTP"
                            bg="#000"
                            color="#f35f37"
                            hoverColor="#f35f37"
                            hoverBg="#000"
                            type="submit"
                          />

                          <div
                            className="common_back_icon"
                            onClick={() => {
                              setStep(1);
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faArrowLeft}
                              className="inner_icon"
                            />
                          </div>
                        </>
                      )}
                    </Form>

                    {/* OTP Box - Appears after Send OTP */}
                    {showOtpBox && (
                      <>
                        <div className="d-flex otp-box justify-content-center gap-3 mb-3 mt-3">
                          {otp.map((digit, idx) => (
                            <Form.Control
                              key={idx}
                              ref={(el) => (inputRefs.current[idx] = el)}
                              type="text"
                              maxLength={1}
                              value={digit}
                              onChange={(e) =>
                                handleOtpChange(idx, e.target.value)
                              }
                              onKeyDown={(e) => handleKeyDown(idx, e)}
                              className="otp-input text-center rounded"
                              required
                            />
                          ))}
                        </div>

                        {otpError && (
                          <div className="text-danger text-center mt-2">
                            {otpError}
                          </div>
                        )}

                        <small className="d-block did-receive">
                          Didn't Receive OTP?{" "}
                          {canResend ? (
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleResendOtp();
                              }}
                            >
                              <strong className="resed">Resend Now!</strong>
                            </a>
                          ) : (
                            <span>Resend in {timer}s</span>
                          )}
                        </small>

                        <WhiteButton
                          className="center-btn submit-otp-button"
                          title="Submit OTP"
                          bg="#000"
                          color="#f35f37"
                          hoverColor="#f35f37"
                          hoverBg="#000"
                          type="button"
                          onClick={verifyOtpHandler}
                        />
                      </>
                    )}
                  </Card.Body>
                </Card>
              )}

              {/* Reset Password Screen */}
              {step === 5 && (
                <Card className="login-card border-0">
                  <Card.Body className="card-body p-4 text-center">
                    <img
                      className="main-logo"
                      src="images/logo/logo.png"
                      alt="Spirulina"
                    />
                    <h6 className="welcome-title">RESET PASSWORD</h6>

                    <Form
                      className="mt-3 input-form"
                      onSubmit={handleSubmit(handleForgotReset)}
                    >
                      <div className="password_holder">
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          className="rounded-pill mb-2 input-filed"
                          placeholder="Enter New Password"
                          {...register("password", {
                            required: "Password is required",
                            minLength: {
                              value: 6,
                              message: "Minimum 6 characters",
                            },
                          })}
                        />
                        {errors.password && (
                          <small className="text-danger">
                            {errors.password.message}
                          </small>
                        )}

                        <div className="eye-icc">
                          <FontAwesomeIcon
                            icon={iconOne}
                            className="icon"
                            onClick={() => togglePasswordVisibility("password")}
                          />
                        </div>
                      </div>

                      <div className="password_holder">
                        <Form.Control
                          type={showPasswordOne ? "text" : "password"}
                          className="rounded-pill mb-2 input-filed"
                          placeholder="Enter Confirm Password"
                          {...register("confirm_password", {
                            required: "Confirm password is required",
                            validate: (val) =>
                              val === password || "Passwords do not match",
                          })}
                        />
                        {errors.confirm_password && (
                          <small className="text-danger">
                            {errors.confirm_password.message}
                          </small>
                        )}

                        {generalError && (
                          <small className="text-danger d-block mt-2">
                            {generalError}
                          </small>
                        )}

                        <div className="eye-icc">
                          <FontAwesomeIcon
                            icon={iconTwo}
                            className="icon"
                            onClick={() =>
                              togglePasswordVisibility("reenterPassword")
                            }
                          />
                        </div>
                      </div>

                      <WhiteButton
                        className="center-btn submit-otp-button"
                        title="RESET PASSWORD"
                        bg="#000"
                        color="#f35f37"
                        hoverColor="#f35f37"
                        hoverBg="#000"
                        type="submit"
                      />

                      <div
                        className="common_back_icon"
                        onClick={() => {
                          setStep(4);
                          setOtp(["", "", "", ""]);
                          setShowOtpBox(false);
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faArrowLeft}
                          className="inner_icon"
                        />
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              )}
            </Col>
          ) : (
            /* SIGNUP SECTION - Kept exactly as you had */
            <Col
              xs={12}
              md={6}
              lg={6}
              className="d-flex justify-content-center right-form"
            >
              <Card className="login-card border-0">
                <Card.Body className="card-body p-4 text-center">
                  <img
                    className="main-logo"
                    src="images/logo/logo.png"
                    alt="Spirulina"
                  />
                  <h6 className="welcome-title">
                    Unlock the power of Spirulina
                  </h6>

                  <div className="mt-3 input-form">
                    {signupStep === 1 && (
                      <>
                        <div className="phone-input-wrapper">
                          <Form.Control
                            maxLength={10}
                            className="rounded-pill mb-2 input-filed pe-5"
                            placeholder="Enter Contact No."
                            disabled={showOtpBox && !canResend}
                            {...register("mobile_number", {
                              required: "Phone is required",
                              pattern: {
                                value: /^[0-9]{10}$/,
                                message: "Enter valid 10 digit number",
                              },
                              onChange: () => {
                                setMobileError("");
                                setGeneralError("");
                              },
                            })}
                            onInput={(e) =>
                            (e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              "",
                            ))
                            }
                          />
                        </div>
                        {errors.mobile_number && (
                          <small className="text-danger">
                            {errors.mobile_number.message}
                          </small>
                        )}
                        {mobileError && (
                          <small className="text-danger d-block">
                            {mobileError}
                          </small>
                        )}

                        {!showOtpBox && (
                          <>
                            <WhiteButton
                              className="center-btn submit-otp-button"
                              // title="Send OTP"
                              title={canResend ? "Resend OTP" : "Send OTP"}
                              bg="#000"
                              color="#f35f37"
                              hoverColor="#f35f37"
                              hoverBg="#000"
                              type="button"
                              onClick={handleSubmit(sendOtpHandler)}
                            />

                            <div
                              className="common_back_icon"
                              onClick={() => {
                                setFormType("login");
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faArrowLeft}
                                className="inner_icon"
                              />
                            </div>
                          </>
                        )}

                        {showOtpBox && (
                          <>
                            <div className="d-flex otp-box justify-content-center gap-3 mb-3 mt-3">
                              {otp.map((digit, idx) => (
                                <Form.Control
                                  key={idx}
                                  ref={(el) => (inputRefs.current[idx] = el)}
                                  type="text"
                                  maxLength={1}
                                  value={digit}
                                  onChange={(e) =>
                                    handleOtpChange(idx, e.target.value)
                                  }
                                  onKeyDown={(e) => handleKeyDown(idx, e)}
                                  className="otp-input text-center rounded"
                                />
                              ))}
                            </div>
                            {otpError && (
                              <div className="text-danger text-center mt-2">
                                {otpError}
                              </div>
                            )}
                            {otpVerified && (
                              <div className="text-success text-center mt-2">
                                ✅ OTP Verified
                              </div>
                            )}

                            <small className="d-block did-receive">
                              Didn't Receive OTP?{" "}
                              {canResend ? (
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleResendOtp();
                                  }}
                                >
                                  <strong className="resed">Resend Now!</strong>
                                </a>
                              ) : (
                                <span>Resend in {timer}s</span>
                              )}
                            </small>

                            {!otpVerified && (
                              <>
                                <WhiteButton
                                  className="center-btn submit-otp-button"
                                  title="Submit OTP"
                                  bg="#000"
                                  color="#f35f37"
                                  hoverColor="#f35f37"
                                  hoverBg="#000"
                                  type="button"
                                  onClick={verifyOtpHandler}
                                />

                                <div
                                  className="common_back_icon"
                                  onClick={() => {
                                    setShowOtpBox(false);
                                    setOtp(["", "", "", ""]);
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={faArrowLeft}
                                    className="inner_icon"
                                  />
                                </div>
                              </>
                            )}

                            {otpVerified && (
                              <WhiteButton
                                className="center-btn submit-otp-button"
                                title="Continue"
                                bg="#000"
                                color="#f35f37"
                                hoverColor="#f35f37"
                                hoverBg="#000"
                                type="button"
                                onClick={() => setSignupStep(2)}
                              />
                            )}
                          </>
                        )}
                      </>
                    )}

                    {signupStep === 2 && (
                      <Form onSubmit={handleSubmit(handleSignupFinal)}>
                        <div className="password_holder">
                          <Form.Control
                            type={showPassword ? "text" : "password"}
                            className="rounded-pill mb-2 input-filed"
                            placeholder="Enter Password"
                            {...register("password", {
                              required: "Password is required",
                              onChange: () => {
                                setGeneralError("");
                              },
                            })}
                          />
                          {errors.password && (
                            <small className="text-danger">
                              {errors.password.message}
                            </small>
                          )}

                          <div className="eye-icc">
                            <FontAwesomeIcon
                              icon={iconOne}
                              className="icon"
                              onClick={() =>
                                togglePasswordVisibility("password")
                              }
                            />
                          </div>
                        </div>

                        <div className="password_holder">
                          <Form.Control
                            type={showPasswordOne ? "text" : "password"}
                            className="rounded-pill mb-2 input-filed"
                            placeholder="Enter Confirm Password"
                            {...register("confirm_password", {
                              required: "Confirm password is required",
                              validate: (val) =>
                                val === password || "Passwords do not match",
                            })}
                          />
                          {errors.confirm_password && (
                            <small className="text-danger">
                              {errors.confirm_password.message}
                            </small>
                          )}

                          <div className="eye-icc">
                            <FontAwesomeIcon
                              icon={iconTwo}
                              className="icon"
                              onClick={() =>
                                togglePasswordVisibility("reenterPassword")
                              }
                            />
                          </div>
                        </div>

                        <Form.Control
                          type="text"
                          className="rounded-pill mb-2 input-filed"
                          placeholder="Enter Referral Code"
                          {...register("invitation_referral_code", {
                            required: "Referral code is required",
                          })}
                        />

                        {errors.invitation_referral_code && (
                          <small className="text-danger">
                            {errors.invitation_referral_code.message}
                          </small>
                        )}

                        {generalError && (
                          <small className="text-danger d-block mt-2">
                            {generalError}
                          </small>
                        )}
                        <div className="signup-wrapper text-center ">
                          <b>Don't have a referral code? Use "ADMIN". </b>
                        </div>

                        <WhiteButton
                          className="center-btn submit-otp-button"
                          title="Sign Up"
                          bg="#000"
                          color="#f35f37"
                          hoverColor="#f35f37"
                          hoverBg="#000"
                          type="submit"
                        />

                        <div
                          className="common_back_icon"
                          onClick={() => {
                            setSignupStep(1);
                            setOtp(["", "", "", ""]);
                            setOtpVerified(false);
                            setShowOtpBox(false);
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faArrowLeft}
                            className="inner_icon"
                          />
                        </div>
                      </Form>
                    )}
                  </div>

                  <div className="signup-wrapper text-center mt-3">
                    <span>
                      Already have an account?{" "}
                      <a
                        onClick={() => {
                          setFormType("login");
                          setStep(1);
                          reset();
                          setPhone("");
                          setOtp(["", "", "", ""]);
                          setShowOtpBox(false);
                          setOtpVerified(false);
                        }}
                        className="signup-link"
                      >
                        Log in
                      </a>
                    </span>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          )}
        </Row>
      </Container>

      <Modal
        show={showInactiveModal}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body className="text-center p-4">
          <h4 className="mb-3">Account Inactive</h4>

          <p>{inactiveMessage}</p>

          <Button
            variant="dark"
            onClick={() => {
              setShowInactiveModal(false);

              sessionStorage.removeItem("inactive_message");

              navigate("/");
            }}
          >
            OK
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
}
